export const getDefaultAddressPostCode = (addresses) => {
  const defaultAddress = addresses.find(address => address.default === 'y' && address.line1 !== 'DUMMY' && address.city !== 'DUMMY')
  return defaultAddress && defaultAddress.postcode ? defaultAddress.postcode : ''
}



// WEBPACK FOOTER //
// ./services/api/parser/profile/index.js